module.exports = __webpack_public_path__ + "img/sdsk.cfb47510.svg";